import React, { PropTypes } from 'react';
import { NitroHeading, NitroButton, NitroParagraph, NitroIcon } from 'nitro-components';
import Status from '../../../../components/utils/Status';

import styled from 'styled-components';

import QuoteApproverNote from './QuoteApproverNote';

import moment from 'moment';
import { formatStatus } from '../helper';

import { compose, withState, withHandlers } from 'recompose';

import { QuoteListContainer, QuoteList, QuoteListItem, ListContent } from './QuoteList';

const enhance = compose(
  withState('active', 'toggle', false),
  withHandlers({
    toggle: props => () => props.toggle(active => !active)
  })
);

const ListHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid ${props => props.theme.color.border};
  line-height: 60px;
`;

const ListHeadingStatus = styled.div`
  margin-left: auto;
  margin-right: 8px;
`;

const QuoteStatusList = enhance(({
  active,
  statusList,
  status,
  toggle,
  action,
  quoteId,
  emailList
}) => {
  if (!statusList) {
    return null;
  }

  let list = statusList.map((item, index) => {
    if (!item.Status || item.Status.Id === 5) {
      return null;
    }

    const emailCheck = emailList[`${quoteId}-${item.ApproverId}`];
    const emailLabel = emailCheck ? 'Email sent' : 'Send email';

    return (
      <QuoteListItem key={index}>
        <ListContent>

          <Status layout="horizontal" noLabel {...formatStatus(item.Status, status, index === 0)} />
          <NitroParagraph size="4" noMargin>{item.ApproverName}</NitroParagraph>
          {item.Status.Id === 1
            ? <div style={{ whiteSpace: 'nowrap' }}>
                <NitroButton
                  disabled={emailCheck}
                  loading={emailCheck === false}
                  label={emailLabel}
                  size="extraSmall"
                  action={() => action(item)}
                />
              </div>
            : <NitroParagraph
                size="4"
                variant="base3"
                noMargin
              >{moment(item.ActionedDate).format('Do MMM YYYY').toString()}</NitroParagraph>}
        </ListContent>
        {item.Notes && <QuoteApproverNote note={item.Notes} />}
      </QuoteListItem>
    );
  });

  const iconDirection = active ? 'up' : 'down';
  return (
    <div>
      <ListHeading onClick={toggle}>
        <NitroHeading size="3" label="Status" noMargin variant="secondary" />
        <ListHeadingStatus>
          <Status layout="horizontal" {...formatStatus(status)} />
        </ListHeadingStatus>
        <NitroIcon name={`arrow-${iconDirection}-solid`} size={8} variant="secondary" />
      </ListHeading>
      {active &&
        <QuoteListContainer>
          <QuoteList>
            {list}
          </QuoteList>
        </QuoteListContainer>}
    </div>
  );
});

QuoteStatusList.propTypes = {
  active: PropTypes.bool,
  statusList: PropTypes.array,
  status: PropTypes.object,
  action: PropTypes.func,
  toggle: PropTypes.func,
  emailList: PropTypes.object.isRequired,
  quoteId: PropTypes.string.isRequired
};

export default QuoteStatusList;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/components/QuoteStatusList.js